import { Component, Input, effect } from '@angular/core';
import { AppStateService } from 'src/app/shared/services/helpers/app-state.service';
import * as _ from 'lodash'
import { NgIf } from '@angular/common';
import { LtmsLoaderComponent } from '../../../../shared/components/ltms-loader/ltms-loader.component';

@Component({
    selector: 'app-action-ageing-actionable-issue-count',
    templateUrl: './action-ageing-actionable-issue-count.component.html',
    styleUrls: ['./action-ageing-actionable-issue-count.component.scss'],
    imports: [NgIf, LtmsLoaderComponent]
})
export class ActionAgeingActionableIssueCountComponent {
  @Input() totalResponses: string | null = '';
  @Input() totalActionableResponses: string | null = '';
  tatHours: any = 0;
  leftUpperBoxHeading: string = 'Actionable Issues';
  leftUpperBoxDiscription: string = 'Viewing average age for unsolved Actionable Issues. Age is computed during Business Hours. Target TAT is '+ this.tatHours + ' hours.';

  constructor(
    private _appStateService: AppStateService
  ) {
    effect(() => {
      if (this._appStateService.initialized()) {
        const brandDetails: any = this._appStateService.brandDetails()
        this.tatHours = _.get(brandDetails, "action_management_configuration.ageing_config.turnaround_time", 0);
        this.leftUpperBoxDiscription = 'Viewing average age for unsolved Actionable Issues. Age is computed during Business Hours. Target TAT is ' + this.tatHours + ' hours.';
      }
    })
  }
}
